// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"15":"6461c8fd","347":"6912459d","454":"a09a97a5","501":"8dc3b995"}[chunkId] + ".chunk.css";
};